module.exports = __webpack_public_path__ + "static/media/walkin_logo_white.218d0bd6.png";